import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Fábrica propia, no intermediarios",
    text: "En ANGORA el acero no pasa por tres manos antes de llegar a tu obra. Rolamos, cortamos y conformamos en nuestra planta del Parque Industrial Topolobampo, por eso respondemos más rápido y con mejor precio que cualquier revendedor.",
  },
  {
    n: "02",
    title: "La lámina es nuestro fuerte",
    text: "Galvanizada, acanalada, pintro, antiderrapante, losacero y rollo. Todo tipo de lámina, en todos los calibres y largos, fabricada aquí mismo en Los Mochis.",
  },
  {
    n: "03",
    title: "De Los Mochis, desde 2017",
    text: "Casi una década abasteciendo constructoras, talleres de herrería y familias que construyen su patrimonio. Cada entrega lleva el respaldo de una fábrica sinaloense.",
  },
];

export default function Nosotros() {
  return (
    <section id="nosotros" className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 md:py-32" data-testid="nosotros-section">
      <div className="grid md:grid-cols-12 gap-10 md:gap-16">
        <div className="md:col-span-5">
          <div className="md:sticky md:top-28">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#FF7A00]" />
              <span className="font-mono-ind text-[11px] tracking-[0.25em] uppercase text-[#8B95A5]">Nosotros</span>
            </div>
            <h2 className="font-display font-black tracking-tighter leading-[0.95] text-4xl sm:text-5xl lg:text-6xl" style={{ fontWeight: 900 }}>
              Forjado en<br /><span className="text-outline-amber">Los Mochis.</span>
            </h2>
            <p className="mt-6 text-sm md:text-base text-[#8B95A5] leading-relaxed max-w-md">
              ANGORA MATERIALES nació en 2017 con una idea simple: que el acero para construir
              se compre directo en fábrica, sin rodeos y sin sobreprecios.
            </p>
          </div>
        </div>

        <div className="md:col-span-7">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="border-t border-[#1A2235] py-8 md:py-10 flex gap-6 md:gap-10"
            >
              <span className="font-display font-black text-4xl md:text-6xl text-outline shrink-0 leading-none" style={{ fontWeight: 900 }}>{c.n}</span>
              <div>
                <h3 className="font-display text-xl md:text-2xl font-bold tracking-tight">{c.title}</h3>
                <p className="mt-3 text-sm md:text-base text-[#8B95A5] leading-relaxed">{c.text}</p>
              </div>
            </motion.div>
          ))}

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="mt-6 grid grid-cols-12 gap-4 md:gap-6 items-end"
          >
            <div className="col-span-8 border border-[#1A2235] rounded-sm overflow-hidden group">
              <img src="/assets/negocio.jpg" alt="Planta ANGORA MATERIALES en Parque Industrial Topolobampo, Los Mochis"
                className="w-full aspect-[16/10] object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
            </div>
            <div className="col-span-4 border border-[#1A2235] rounded-sm overflow-hidden group">
              <img src="/assets/products/soldadura.jpg" alt="Soldadura en planta ANGORA"
                className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
            </div>
            <p className="col-span-12 font-mono-ind text-[11px] tracking-[0.2em] uppercase text-[#8B95A5] mt-2">
              Planta y almacén — Parque Industrial Topolobampo, Los Mochis, Sinaloa
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
